import {
  Listbox,
  ListboxButton,
  ListboxOption,
  ListboxOptions,
} from "@headlessui/react";
import { CaretDownIcon } from "@phosphor-icons/react";

import { clsx } from "@alpacahq/ui/old";

import type { PositionIntent } from "~/v2/constants/optionOrder";

interface PositionIntentOption {
  value: PositionIntent;
  label: string;
  side: "buy" | "sell";
}

interface PositionIntentSelectorProps {
  value: PositionIntent;
  onChange: (intent: PositionIntent) => void;
  options: PositionIntentOption[];
}

export const PositionIntentSelector = ({
  value,
  onChange,
  options,
}: PositionIntentSelectorProps) => {
  const selected = options.find((o) => o.value === value) ?? options[0];
  const isSell = selected.side === "sell";

  return (
    <Listbox
      value={selected}
      onChange={(option: PositionIntentOption) => onChange(option.value)}
    >
      <div className="relative">
        <ListboxButton className="flex cursor-pointer items-center gap-1 border-none bg-transparent p-0">
          <span
            className={clsx(
              "font-medium text-sm leading-5",
              isSell ? "text-red-600" : "text-emerald-600",
            )}
          >
            {selected.label}
          </span>
          <CaretDownIcon
            size={16}
            className={clsx(isSell ? "text-red-600" : "text-emerald-600")}
          />
        </ListboxButton>
        <ListboxOptions className="absolute z-10 mt-1 w-40 rounded border border-gray-300 bg-white p-1 shadow-md">
          {options.map((option) => (
            <ListboxOption key={option.value} value={option}>
              {({ selected: isSelected }) => (
                <div
                  className={clsx(
                    "cursor-pointer rounded px-2 py-1.5 font-medium text-sm",
                    "hover:bg-gray-50",
                    isSelected && "bg-[rgba(199,210,254,0.24)]",
                    option.side === "sell"
                      ? "text-red-600"
                      : "text-emerald-600",
                  )}
                >
                  {option.label}
                </div>
              )}
            </ListboxOption>
          ))}
        </ListboxOptions>
      </div>
    </Listbox>
  );
};
